import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api'

// =====================================================
// TYPES
// =====================================================

export interface StaffingScheduleItem {
  id: string
  code: string
  code_1c: string
  name: string
  department_id: string | null
  department_name: string
  department?: { id: string; name: string } | null
  position_id: string | null
  position_uid: string | null
  position_name: string
  position?: { id: string; name: string } | null
  date: string
  is_active: boolean
  rate_count: number
  work_schedule: string | null
  schedule_template?: { id: string; name: string } | null
  salary: number | null
  payroll_fund: number | null
  created_at: string
  updated_at: string
}

export interface StaffingScheduleFilters {
  departmentId?: string
  positionId?: string
  isActive?: boolean
  search?: string
  page?: number
  limit?: number
  sort?: string
}

export interface PaginatedStaffingSchedule {
  data: StaffingScheduleItem[]
  total: number
  page: number
  limit: number
  totalPages: number
}

// =====================================================
// HOOKS
// =====================================================

const STAFFING_SCHEDULE_QUERY_KEY = 'staffing-schedule'

export function useStaffingSchedule(filters: StaffingScheduleFilters) {
  return useQuery<PaginatedStaffingSchedule>({
    queryKey: [STAFFING_SCHEDULE_QUERY_KEY, filters],
    queryFn: () => apiClient.getStaffingSchedule(filters) as Promise<PaginatedStaffingSchedule>,
  })
}
